// extracted by mini-css-extract-plugin
export default {"table":"LiveSupport_table__R7Xzs","header":"LiveSupport_header__iTyl0","row":"LiveSupport_row__mcrVI","unread_row":"LiveSupport_unread_row__HoV3k"};